import { useMutation } from "@tanstack/react-query";
import { customInstance } from "~/custom-instance";

type TextSnipRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

type TextSnipPoint = {
  x: number;
  y: number;
};

type TextSnipRequest = {
  organizationId: string;
  projectId: string;
  pageId: string;
  rect: TextSnipRect;
  polygon?: TextSnipPoint[];
};

type TextSnipResponse = {
  text: string;
  pageId: string;
};

const TEXT_SNIP_TIMEOUT_MS = 15_000;

const postTextSnip = async ({
  organizationId,
  projectId,
  pageId,
  rect,
  polygon,
}: TextSnipRequest): Promise<TextSnipResponse> => {
  const baseUrl = import.meta.env.VITE_BASE_API_URL;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), TEXT_SNIP_TIMEOUT_MS);

  try {
    return await customInstance<TextSnipResponse>({
      url: `${baseUrl}/organizations/${organizationId}/projects/${projectId}/pages/${pageId}/text-snip`,
      method: "post",
      data: polygon ? { rect, polygon } : { rect },
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeout);
  }
};

export const useTextSnipMutation = () => {
  return useMutation({
    mutationFn: postTextSnip,
    retry: false,
  });
};
